
import React, { Component } from 'react';
import './add-class-section.scss'
import { Modal, ModalBody } from "reactstrap";

import SchoolApi from '../../../apis/school'
import { ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import ClassComponent from '../../class/setup-class/setup-class'

class AddClassSectionComponent extends Component {
    constructor(props) {
        super(props)
        this.state.selectedUser = this.props.selectedUser;

        if (this.props.mode === 'EDIT') {
            this.state.firstName = this.props.selectedUser.firstName;
            this.state.lastName = this.props.selectedUser.lastName;
            this.state.email = this.props.selectedUser.email;
            this.state.selectedCountryCode = this.props.selectedUser.countryCode;
            this.state.mobileNumber = this.props.selectedUser.mobileNumber;
            this.state.landline = this.props.selectedUser.landline;
            this.state.gender = this.props.selectedUser.gender

            this.props.selectedUser.types.filter(type => {

                if (!this.state.mathSelected) {
                    this.state.mathSelected = (type.type == "MATH_TEACHER")
                }

            })

        }

    }

    state = {

        types: [],
        selectedCountryCode: '+91',
        gender: 'Mr.',
        classSection: { MATH: [{}], CLASS: [{}] },
        sections: {},
        classHash: null,
        selectedClass: '',
        classes: []
    }

    selectedSectionHash = {}

    componentDidMount() {
        this.getSections();
    }



    getSections(payload = {}) {

        let sections = {}, classes = []
        SchoolApi.getSections(payload)
            .then(response => {

                let res = response.response, selectedSections = []
                for (let i = 0; i < res.length; i++) {
                    let disabled = res[i].teacherId && this.props.selectedUser._id != res[i].teacherId
                    let selected = res[i].teacherId && this.props.selectedUser._id == res[i].teacherId

                    if (!sections[res[i].class]) {
                        sections[res[i].class] = [{
                            name: res[i].section,
                            id: res[i]._id,
                            disabled
                        }]
                    } else {
                        sections[res[i].class].push({
                            name: res[i].section,
                            id: res[i]._id,
                            disabled
                        })
                    }

                    if (selected) {
                        selectedSections.push(res[i]._id)
                        this.selectedSectionHash[res[i]._id] = true
                    }
                }

                for (let key in sections) {
                    let obj = {
                        name: key,
                        sections: sections[key]
                    }
                    classes.push(obj)
                }

                this.setState({ classes, selectedSections })

            }).catch(err => {

                this.setState({ classes: [], selectedSections: "" })
            })
    }

    onSelectSection = (option) => {
        if (option.disabled) return
        let newSections = this.state.selectedSections || []
        if (this.selectedSectionHash[option.id]) {
            this.selectedSectionHash[option.id] = false
            let sections = this.state.selectedSections
            newSections = []
            sections.map(item => {
                if (option.id != item) {
                    newSections.push(item)
                }
            })
        } else {
            this.selectedSectionHash[option.id] = true
            newSections.push(option.id)
        }

        this.setState({ selectedSections: newSections })
    }

    onSave() {
        let payload = {
            _id: this.state.selectedSections,
            teacherId: this.props.selectedUser._id
        }

        if (!this.state.selectedSections?.length) {
            this.setState({ errorMessage: "Please Select atleast one section" })
            return
        }

        SchoolApi.updateSections(payload).then(response => {
            if (this.props.onClose) {
                this.props.onClose()
            }
        }).catch(err => {

        })
    }



    render() {
        return (
            <div>
                <Modal className={`cw-custom-modal ${this.state.addNewClassModal ? "display-none" : ""}`} isOpen={this.props.show} toggle={this.props.onClose} size={this.props.size || 'md'}>

                    <ModalBody >

                        <div className="row">
                            <div className="col">
                                <img className="close-icon cursor-pointer" onClick={this.props.onClose} src={getImageSource(ImageConstants.CROSS)} />
                            </div>
                        </div>

                        <div className="add-class-section">

                            <div className="header-text text-center">
                                <div>EDIT CLASS OR SECTION</div>
                                <div className="teacher-name">for {this.state.selectedUser?.firstName}</div>
                            </div>

                            <div className="section-wrapper pt-5">
                                <div className="row ">
                                    <div className="col-2 section-title"> CLASS </div>
                                    <div className="col section-title"> SECTIONS </div>
                                </div>
                                <div className="py-4">
                                    {
                                        this.state.classes.map(item => (
                                            <div className="row py-2">
                                                <div className="col-2 my-auto">{item.name}</div>
                                                <div className="col">
                                                    <div className="row">
                                                        {
                                                            item?.sections.map(section => (
                                                                <div className={`col-2 section my-auto text-center ml-2 py-2 ${section.disabled ? "section-disabled" : ""} ${this.selectedSectionHash[section?.id] ? "selected-section" : "not-selected"} `} onClick={() => this.onSelectSection(section)}>
                                                                    {section.name}
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>

                            <div className="text-center pt-4">
                                {this.state.errorMessage ? <div className="text-danger pb-4"><strong>{this.state.errorMessage} </strong></div> : ""}

                                <button className="cw-button-primary" onClick={() => this.onSave()}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </ModalBody>

                </Modal >

                {this.state.addNewClassModal ? <ClassComponent show={this.state.addNewClassModal} size="lg" title="Class" onClose={this.hideNewClass} /> : ""}
            </div>
        );
    }
}

export default AddClassSectionComponent;